import "./aboutus.css";
// import customerpic from "../../assets/about/486187185_18047472695343245_2429032065357544551_n.jpg";
// import customerphone from '../../assets/about/482123607_18045200834343245_6032584008707992827_n.jpg';
import { Link } from "react-router-dom";
import Nav from "../Nav/Nav";
import Footer from "../Footer/Footer";

const AboutUs = () => {
  return (
    <>
      <Nav theme="light" />
      <section className="about-section">
        <div className="overlay">
          <div className="content">
            <h1>About Us</h1>
            <p>
              Galaxcity Gadgets, based in Imphal, is an Apple Authorised
              Reseller and Samsung Partner Store. We are focused on providing a
              hands-on experience and elevating the customer retail journey
              through premium products, trusted brands, and personalised
              service.
            </p>
          </div>
        </div>
      </section>

      <section className="our-story">
        <div className="about-container">
          <h2>Our Story</h2>
          <p>
            Operating since 18 July 2016 and proudly based in Imphal, we are
            more than just an electronics store—we’re a place where you can
            truly experience technology. At our store, it’s not just about
            buying a device—it’s about experiencing it first. We’ve created a
            space where customers can see, feel, and try products before making
            a decision. We deal with premium brands known for their quality,
            reliability, and strong after-sales support, offering everything
            from smartphones and accessories to smart devices and audio gear.
            We’ve also extended this experience-first approach to our social
            media platforms, where we create content that gives you a real,
            POV-style feel of using a product—helping you understand its
            potential before you even purchase it. We don’t just focus on
            sales—we focus on helping our customers make confident choices and
            enjoy a seamless tech journey from start to finish.
          </p>
        </div>
      </section>

      {/* <section className="team-section">
        <h2>Our Team</h2>
        <div className="team-card">
          <div className="member">
            <img src={customerpic} alt="Robert Hendz" />
            <h4>Robert Hendz</h4>
            <p>Commercial Real Estate</p>
          </div>
          <div className="member">
            <img src={customerpic} alt="Loreen James" />
            <h4>Loreen James</h4>
            <p>Residential Real Estate</p>
          </div>
          <div className="member">
            <img src={customerpic} alt="Mike Benson" />
            <h4>Mike Benson</h4>
            <p>Residential Real Estate</p>
          </div>
          <div className="member">
            <img src={customerpic} alt="Brett Slater" />
            <h4>Brett Slater</h4>
            <p>Commercial Real Estate</p>
          </div>
        </div>
        <div className="button-wrapper">
          <div className="contact-btn">
            <button
              onClick={() => {
                navigate("/contactus");
              }}
            >
              Contact us
            </button>
          </div>
        </div>
      </section> */}

      <section className="search-banner">
        <div className="overlay">
          <div className="content">
            <h1>START YOUR SEARCH TODAY</h1>
            <p>
              At GALAXCITY, we believe finding the perfect mobile phone should
              be simple, fast, and hassle-free. Whether you're looking for the
              latest flagship model or a budget-friendly device, we’ve got you
              covered. Our curated collection includes top brands, great deals,
              and trusted reviews to help you make the right choice. We’re
              committed to quality, transparency, and excellent customer service
              — so you can shop with confidence.
            </p>

            <Link to="/" className="btn">
              BROWSE LISTINGS
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutUs;
